import { collection, query, where, getDocs, orderBy, doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

export interface Notification {
  id: string;
  contractId: string;
  userId: string;
  message: string;
  read: boolean;
  createdAt: Timestamp;
}

/**
 * Fetches all notifications for the current user
 */
export const getNotificationsForUser = async (userId: string): Promise<Notification[]> => {
  try {
    const notificationsRef = collection(db, 'notifications');
    const q = query(
      notificationsRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    })) as Notification[];
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw new Error('حدث خطأ أثناء جلب الإشعارات');
  }
};

/**
 * Marks a notification as read
 */
export const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  try {
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, { read: true });
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw new Error('حدث خطأ أثناء تحديث حالة الإشعار');
  }
};

/**
 * Marks all notifications as read for a user
 */
export const markAllNotificationsAsRead = async (userId: string): Promise<void> => {
  try {
    const notifications = await getNotificationsForUser(userId);
    const batch = [];
    
    for (const notification of notifications) {
      if (!notification.read) {
        const notificationRef = doc(db, 'notifications', notification.id);
        batch.push(updateDoc(notificationRef, { read: true }));
      }
    }
    
    if (batch.length > 0) {
      await Promise.all(batch);
    }
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw new Error('حدث خطأ أثناء تحديث حالة الإشعارات');
  }
};
